import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'split-in-batches',
  version: '3.0.0',
  properties: [
    {
      key: 'batchSize',
      label: 'Batch Size',
      type: 'number',
      required: true,
      default: 10,
      typeOptions: {
        minValue: 1,
        maxValue: 10000,
        numberStepSize: 1,
      },
      description: 'Number of items to include in each batch',
    },
    {
      key: 'inputArray',
      label: 'Input Array',
      type: 'string',
      placeholder: '{{ $node["NodeName"].array }}',
      description: 'Array to split into batches. Leave empty to use input data automatically.',
    },
    {
      key: 'options',
      label: 'Options',
      type: 'collection',
      default: {},
      section: 'settings',
      values: [
        {
          key: 'reset',
          label: 'Reset on Re-run',
          type: 'boolean',
          default: false,
          description: 'Reset batch counter when workflow is re-executed',
        },
        {
          key: 'outputFieldName',
          label: 'Output Field Name',
          type: 'string',
          default: 'batches',
          placeholder: 'batches',
          description: 'Name of the output field containing batches',
        },
      ],
    },
  ],
};

export default schema;
